export const getAvatarPlaceholderByFullName = (fullName = ''): string => {
  const fullNameWords = fullName.trim().split(' ');
  const [surname, name = ''] = fullNameWords;

  return `${surname.charAt(0)}${name.charAt(0)}`.toUpperCase();
};
